import { isAccountReadCopyKey, nextAccountGeneration } from "@heraion/shared";

import { dropLsCopies } from "../lsCache";
import { invalidateSelfSessionResults } from "../progress/progressDeps";

// #397, mobile's dropAccountCaches (apps/mobile/src/auth/cognito.ts): the read
// copies (`jl.asyncList.*` and lsCache's own in localStorage, the Progress
// results in memory) are the last account's, and the MAXes among them seed
// loads. Sign-out drops them, and so does a sign-in. The generation moves
// first, so a read still out for that account writes no copy when it lands.
// The editor drafts and the logger draft are work: they stay.
export function dropAccountCaches(): void {
  nextAccountGeneration();
  invalidateSelfSessionResults();
  dropLsCopies();
  try {
    const stale: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key !== null && isAccountReadCopyKey(key)) stale.push(key);
    }
    for (const key of stale) localStorage.removeItem(key);
  } catch {
    // No localStorage (refused): the asyncList copies could not be written.
  }
}
